import React from "react"
import { Link } from "gatsby"
import Logo from "../assets/graphics/svg/shipx-logo.svg"
import { ShipXLogo } from "../components/svg"

const Footer = () => {
  const menu = [
    {
      anchorText: "Privacy Policy",
      link: "/privacy-policy/",
      button: false,
    },
    {
      anchorText: "Terms of Service",
      link: "/terms-of-service/",
      button: false,
    },
    {
      anchorText: "Blog",
      link: "/blog/",
      button: false,
    },
    {
      anchorText: "Contact Us",
      link: "/contact/",
      button: false,
    },
    // {
    //   anchorText: "Become a Broker Agent",
    //   link: "/become-broker-agent/",
    //   button: false,
    // },
  ]
  return (
    <footer className="w-full z-10 bottom-0 sm:justify-between py-8">
      <nav className="flex items-center justify-between flex-wrap z-10 bottom-0 global-container-x">
        <Link to="/">
          <ShipXLogo className="w-48" />
        </Link>
        <div
          className="flex-grow lg:flex lg:items-center lg:w-auto"
          id="nav-content"
        >
          <div className="list-reset lg:flex justify-end flex-1 items-center sm:hidden xs:hidden">
            {menu.map((item, index) => (
              <div key={index} className="mr-3">
                <Link
                  to={item.link}
                  className={
                    item.button === true
                      ? `px-4 py-2 text-white font-semibold border-2 rounded-3xl bg-accent-light hover:bg-accent transition duration-150 ease-in-out`
                      : `inline-block font-semibold text-sm text-gray-300 no-underline hover:text-accent py-2 px-4 transition duration-150 ease-in-out`
                  }
                  activeClassName="text-accent-light hover:text-accent-light font-semibold"
                >
                  {item.anchorText}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </nav>
    </footer>
  )
}
export default Footer
